import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

function CircleStepIcon(props) {
  const { active, completed, icon, className } = props;

  let stateClass = "fs-stepIcon";
  if (active) stateClass += " is-active";
  else if (completed) stateClass += " is-completed";
  else stateClass += " is-inactive";

  return (
    <span className={`${stateClass} ${className || ""}`.trim()}>
      <span className="fs-stepIconNumber">{icon}</span>
    </span>
  );
}

export default function WizardStepper({ steps, activeIndex, onBackStepClick }) {
  return (
    <div className="fs-wrapper">
      <Stepper className="fs-stepper" activeStep={activeIndex} connector={null}>
        {steps.map((label, idx) => {
          const isBackStep = idx < activeIndex;

          return (
            <Step key={`${label}-${idx}`} className="fs-step">
              <StepLabel
                className={
                  isBackStep ? "fs-stepLabel is-clickable" : "fs-stepLabel"
                }
                StepIconComponent={CircleStepIcon}
                onClick={isBackStep ? () => onBackStepClick(idx) : undefined}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
